import { motion } from 'framer-motion';
import { ArrowLeft, Scale } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import LegalContent from '../components/legal/LegalContent';
import { termsOfUse } from '../content/legal';

const TermsOfUse = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-background" data-testid="terms-page">
      <div className="header-safe-top px-6 pb-12 max-w-3xl mx-auto space-y-6">
        <motion.div
          initial={{ opacity: 0, y: 0 }}
          animate={{ opacity: 1, y: 0 }}
          className="flex items-center gap-4"
        >
          <button
            onClick={() => (window.history.length > 1 ? navigate(-1) : navigate('/'))}
            className="p-2 rounded-full hover:bg-secondary/50 transition-colors"
            data-testid="terms-back-button"
            aria-label="Back"
          >
            <ArrowLeft size={24} />
          </button>
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 rounded-full bg-purple-500/10 flex items-center justify-center">
              <Scale size={20} className="text-purple-500" />
            </div>
            <div>
              <h1 className="font-heading font-bold text-2xl" data-testid="terms-title">
                Terms of Use
              </h1>
              <p className="text-muted-foreground text-sm">
                Last updated: {termsOfUse.lastUpdated}
              </p>
            </div>
          </div>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 0 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.1 }}
          className="bg-card border border-border/40 rounded-xl p-6 sm:p-8 shadow-sm"
          data-testid="terms-content"
        >
          <LegalContent blocks={termsOfUse.blocks} />
        </motion.div>

        <p className="text-center text-muted-foreground text-xs">
          Fitxess LLC · Oklahoma, United States · karis@fitxess.com
        </p>
      </div>
    </div>
  );
};

export default TermsOfUse;
